var $ = require('jquery');
var jQuery=$;
$(document).ready(function () {
var pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
$('#footer_btn #btn-mp-submit').click(function () {
    var empty_count = 0;
    var email_val = $('#footer_email').val();
    if (email_val == '' || email_val == null) {
            $("#spftrmail").text("กรุณาใส่อีเมลที่ถูกต้อง");
        empty_count = empty_count + 1;
    }
    else {
        if (!pattern.test($('#footer_email').val())) {
            
                $("#spftrmail").text("กรุณาใส่อีเมลที่ถูกต้อง");
            empty_count = empty_count + 1;
        }
        else {
            $("#spftrmail").text("");
            empty_count = 0;
        }
    }

    if ($("#spftrmail").text() == "" && empty_count == 0) {
        $("#popup_txtEmail").val($("#footer_email").val());
        $('.frm-subscribe').show();
        $('.sucess-frm').hide();
        $('.Footersubscribeform')[0].click();
    }
    else
        return false;

});

$('#footer_email').bind("keypress", function (event) {
    if (event.keyCode == 13) {
        event.preventDefault();
        $("#footer_btn #btn-mp-submit").trigger("click");
    }
});
$('#footer_email').on('keypress keydown keyup paste', function (event) {
    if (event.keyCode != 13) {
        if (!pattern.test($(this).val())) {
                $("#spftrmail").text("กรุณาใส่อีเมลที่ถูกต้อง");
        }
        else {
            $("#spftrmail").text("");
        }
    }
});


var $regexname = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
$('#btnpopupsubscribe a').on('click', function () {
    $('#popup_spEmail').hide();
    $('#popup_spFirstName').hide();
    var location = window.location.href;
    var locat = '';
    if (location.indexOf('?'))
        locat = location.split('?')[0];
    else
        locat = location;

    var email = $("#popup_txtEmail").val();
    //var _lname = $("#txtLastName").val();
    var _fname = $('#popup_txtFirstName').val();
    var $regexname1 = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    var urlss = window.location.origin + "/api/WebApi/subscribe?FirstName=" + _fname + "&Email=" + email;
    //console.log(urlss);
    if (email != "" && _fname != "") {
       // console.log("DddD");
        if (!$('#popup_txtEmail').val().match($regexname1)) {
            $("#popup_spEmail").text("กรุณาใส่อีเมลที่ถูกต้อง");
            $('#popup_spEmail').show();
        }
        else {
            $('#sub-proess').show();
            $("#popup_spEmail").text("");
            $('#popup_spEmail').hide();
            setTimeout(function () {
                $.ajax({
                    url: urlss,
                    type: 'POST',
                    dataType: "json",
                    success: function (data) {
                        //console.log(data);
                        if (data != undefined && data != null) {
                            if (data == "Thanks for subscribing") {
                                $('.frm-subscribe').hide();
                                $('.sucess-frm').show();
                                $('#popup_txtFirstName').val("");
                                $("#popup_txtEmail").val("");
                                $('.thxsub').text("ขอบคุณสำหรับการติดตาม");
                            }
                            else if (data == "Exist" || data.indexOf("BadRequest") != -1) {
                                $('.frm-subscribe').hide();
                                $('#popup_txtFirstName').val("");
                                $("#popup_txtEmail").val("");
                                $('.thxsub').text('อ๊ะ! คุณสมัครเป็นสมาชิก ด้วยอีเมลนี้แล้ว');
                                $('.sucess-frm').show();
                            }
                            else if (data == "resubscribe") {
                                $('.frm-subscribe').hide();
                                $('#popup_txtFirstName').val("");
                                $("#popup_txtEmail").val("");
                                $('.thxsub').text('Thanks for re-subscribing!');
                                $('.sucess-frm').show();
                            }
                            else {
                               // console.log(data);
                            }
                        }

                        $('#sub-proess').hide();
                    },
                    failure: function (response) {
                        $('#sub-proess').hide();
                        //("Failed");
                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        $('#sub-proess').hide();
                       // console.log(thrownError);
                    }
                });
            }, 3000);
        }
    }
    else {
        if (email == "") {
            $('#popup_spEmail').text("กรุณาใส่อีเมลที่ถูกต้อง");
            $('#popup_spEmail').show();
        }
        if (_fname == "") {
            $('#popup_spFirstName').text("กรุณาใส่ชื่อ");
            $('#popup_spFirstName').show();
        }
    }
});

$('#popup_txtEmail').on('keypress keydown keyup', function () {
    if (!$(this).val().match($regexname)) {
        //console.log("assss");
        // there is a mismatch, hence show the error message
        $("#popup_spEmail").text("กรุณาใส่อีเมลที่ถูกต้อง");
        $('#popup_spEmail').show();
    }
    else {
        $("#popup_spEmail").text("");
        $('#popup_spEmail').hide();
    }
});
});